import { computed, inject, Injectable, Injector, signal } from '@angular/core';
import { handleRequestError, LabelType } from '@softline/application';
import { StorageLocation } from '../types/storage-location';
import { StorageLocationRepository } from '../repositories/storage-location.repository';
import { lastValueFrom, Observable } from 'rxjs';

@Injectable()
export class StorageLocationService {
  readonly #storageLocationRepository = inject(StorageLocationRepository);
  readonly #injector = inject(Injector);

  readonly #storageLocation = signal<StorageLocation | null>(null);
  readonly storageLocation = computed(() => this.#storageLocation());

  async getStorageLocation(query: string): Promise<StorageLocation[]> {
    try {
      return lastValueFrom(this.#storageLocationRepository.getStorageLocation(query));
    } catch (e) {
      handleRequestError(e, this.#injector, { show: true });
      return Promise.resolve([]);
    }
  }

  getStorageLocation$(query: string): Observable<StorageLocation[]> {
    return this.#storageLocationRepository.getStorageLocation(query);
  }

  async scanLocation(
    type: LabelType | null | undefined,
    code: string
  ): Promise<StorageLocation> {
    try {
      return await this.#storageLocationRepository.scanLocation(type, code);
    } catch (e) {
      handleRequestError(e, this.#injector, { show: true });
      return Promise.resolve({} as StorageLocation);
    }
  }

  async setSelectedStorageLocation(location: StorageLocation | null) {
    this.#storageLocation.set(location);
  }
}
